module.exports = __webpack_public_path__ + "img/gc_country_flag_co.b1bfc933.svg";